import React from "react";
import { Layout, Card } from 'antd';
import PageTitle from 'shared_components/page_title';

import TabPanes from "modules/lookup_table/tab";

const {Content} = Layout;

function LookupTable() {
    return (
        <div>
            <Card>
                <PageTitle pageTitle="LOOKUP TABLE" />
                <Content>
                    <TabPanes />
                </Content>
            </Card>
        </div>
    )
}

export default LookupTable;